"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sodium = require("libsodium-wrappers-sumo");
var ClassUtil_1 = require("../util/ClassUtil");
var CipherKey = (function () {
    function CipherKey() {
        this.key = new Uint8Array([]);
    }
    CipherKey.new = function (key) {
        var ck = ClassUtil_1.default.new_instance(CipherKey);
        ck.key = key;
        return ck;
    };
    CipherKey.prototype.encrypt = function (plaintext, nonce) {
        if (plaintext instanceof ArrayBuffer && plaintext.byteLength !== undefined) {
            plaintext = new Uint8Array(plaintext);
        }
        return sodium.crypto_stream_chacha20_xor(plaintext, nonce, this.key, 'uint8array');
    };
    CipherKey.prototype.decrypt = function (ciphertext, nonce) {
        return this.encrypt(ciphertext, nonce);
    };
    CipherKey.prototype.encode = function (encoder) {
        encoder.object(1);
        encoder.u8(0);
        return encoder.bytes(this.key);
    };
    CipherKey.decode = function (decoder) {
        var key_bytes = new Uint8Array([]);
        var nprops = decoder.object();
        for (var index = 0; index <= nprops - 1; index++) {
            switch (decoder.u8()) {
                case 0:
                    key_bytes = new Uint8Array(decoder.bytes());
                    break;
                default:
                    decoder.skip();
            }
        }
        return CipherKey.new(key_bytes);
    };
    return CipherKey;
}());
exports.default = CipherKey;
//# sourceMappingURL=CipherKey.js.map


//////////////////
// WEBPACK FOOTER
// ../proteus/dist/derived/CipherKey.js
// module id = 44
// module chunks = 0 1